import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from "@/store";
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import Spinner from 'vue-spinkit'
// don't forget to import CSS styles
import 'tiptap-vuetify/dist/main.css'
import './filters'
import i18n from './i18n'
Vue.component('Spinner', Spinner)
Vue.config.productionTip = false
Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'mdi'
})
new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
